module.exports = __webpack_public_path__ + "static/media/step11.ea614f56.png";